const filesUploadModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/segments/files-upload-modal/files-upload-modal.html',
  controller: 'FilesUploadModalController',
};

angular
    .module('segments.module')
    .component('filesUploadModal', filesUploadModal);
